/*****************************************************************************************
 * 설명 : 프로젝트관리 - 열람신청
 * URI : /project
 * 작성자 :
 * 작성일 :
*****************************************************************************************/
import React, { useState }  from 'react';
import { useFormik } from 'formik';
import * as Yup from "yup";
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';

import { MESSAGE_DELAY } from 'config/config';

import alertMsg from 'components/message';
import AlertDialog from 'components/alertDiolog';
import { InputEx, ToggleButtonGroupEx } from 'components/inputEx';

import Restful from "service/restful";
import { setRequestApplicationApi } from 'service/request';

/*****************************************************************************************
 * 설명 : 함수 선언
*****************************************************************************************/
const ApplicationPerusalModal = (props) => {

  /***************************************************************************************
   * 설명 : 변수 선언부
  ***************************************************************************************/
  const [getApi] = Restful();

  const [openModal, setOpenModal] = useState({open: false, modal: 'message', data: {}});

  /***************************************************************************************
   * 설명 : 업체 검색
  ***************************************************************************************/
  const formik = useFormik({
    initialValues: {
      reason: '',
      isApplicationView: 2,
      isDownload: 1,
    },
    validationSchema: Yup.object().shape({
      reason: Yup.string().max(255, "255자리").required('필수')
    }),
    onSubmit: (values) => {
      submit(values);
    }
  });

  const submit = (values) => {
    let params = {
      projectNumber: props.data.projectNumber,
      reason: values.reason,
      isApplicationView: values.isApplicationView,
      isDownload: values.isDownload,
      list: [props.data]
    }

    setRequestApplicationApi(getApi, params, (response => {
      if( response !== undefined && response.data.result ) {
        alertMsg(response.data.message, "S", MESSAGE_DELAY);

        props.close();

      } else {
        alertMsg(response.data.message || '서버와의 통신에 실패하였습니다.', "E", MESSAGE_DELAY);
      }
    }));
  }

  /***************************************************************************************
   * 설명 : html 선언부
  ***************************************************************************************/
  return (
    <section className="modal">
      <form onSubmit={formik.handleSubmit}>
        <section className="modal-wrap" style={{width: '800px'}}>
          <header className="modal-header" style={{ cursor: 'move' }} id="draggable-dialog-title">
            <div className="modal-title">디자인 프로젝트 파일 열람신청</div>
            <Button className="close-btn" onClick={props.close}>×</Button>
          </header>

          <section className="modal-body">
            <div className="mb10">
              <table className="input-table">
                <colgroup>
                  <col style={{width: '15%'}} />
                  <col style={{width: '35%'}} />
                  <col style={{width: '15%'}} />
                  <col style={{width: '35%'}} />
                </colgroup>

                <tbody>
                  <tr>
                    <th scope="row"><label htmlFor="reason">신청사유</label></th>
                    <td colSpan={3}>
                      <InputEx
                        name="reason"
                        formik={formik}
                        fullWidth={true}
                        placeholder="신청사유"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th scope="row"><label htmlFor="isDownload">다운로드 권한</label></th>
                    <td colSpan={3}>
                      <ToggleButtonGroupEx
                        name="isDownload"
                        exclusive={true}
                        formik={formik}
                        className="search-toggle-btn"
                        data={[
                          {label: '다운로드 및 미리보기', value: 1},
                          {label: '파일 미리보기', value: 2},
                        ]}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <footer className="modal-footer">
            <div className="modal-footer-center">
              <Button
                color="inherit"
                variant="outlined"
                className="Btn"
                onClick={() => {
                  props.close();
                }}
              >창닫기</Button>

              <Button
                type="submit"
                variant="contained"
                color="primary"
                className="Btn ml10"
              >열람신청</Button>
            </div>
          </footer>
        </section>
      </form>

      { openModal.open && openModal.modal === 'dialog' &&
        <Modal
          open={openModal.open}
          onClose={() => setOpenModal({ open: false, modalName: openModal.modal, data: openModal.data })}
        >
          <AlertDialog
            open={openModal.open}
            close={() => setOpenModal({ open: false, modalName: openModal.modal, data: openModal.data })}
            title="열람신청"
            color="primary"
            message={`선택하신 내역으로 열람 신청 하시겠습니까?`}
            confirm="확인"
            onClick={() => {
              submit(formik.values);
            }}
          />
        </Modal>
      }
    </section>
  );
}

/*****************************************************************************************
 * 설명 : default export 선언
*****************************************************************************************/
export default ApplicationPerusalModal;